export const USER_LOGIN = "user/login";

export const CUSTOMER_LOGIN = "customer/login";
export const CUSTOMER_REGISTER = "customer/signup";

export const FORGOT_PASSWORD = (email) =>
  `customer/reset?emailAddress=${email}`;
export const RESET_PASSWORD = "customer/change";
